var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5982_25762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.47266 20.5887H21.1202",
    stroke: "#676767",
    strokeWidth: 1.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47266 6.86289V7.84331C3.47266 8.62337 3.78254 9.37149 4.33413 9.92309C4.88572 10.4747 5.63384 10.7846 6.41391 10.7846C7.19397 10.7846 7.94209 10.4747 8.49368 9.92309C9.04528 9.37149 9.35516 8.62337 9.35516 7.84331M3.47266 6.86289H21.1202M3.47266 6.86289L5.43349 2.94122H19.1593L21.1202 6.86289M9.35516 7.84331V6.86289M9.35516 7.84331C9.35516 8.62337 9.66504 9.37149 10.2166 9.92309C10.7682 10.4747 11.5163 10.7846 12.2964 10.7846C13.0765 10.7846 13.8246 10.4747 14.3762 9.92309C14.9278 9.37149 15.2377 8.62337 15.2377 7.84331M15.2377 7.84331V6.86289M15.2377 7.84331C15.2377 8.62337 15.5475 9.37149 16.0991 9.92309C16.6507 10.4747 17.3988 10.7846 18.1789 10.7846C18.959 10.7846 19.7071 10.4747 20.2587 9.92309C20.8103 9.37149 21.1202 8.62337 21.1202 7.84331V6.86289",
    stroke: "#676767",
    strokeWidth: 1.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43359 20.589V10.6378",
    stroke: "#676767",
    strokeWidth: 1.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1562 20.589V10.6378",
    stroke: "#676767",
    strokeWidth: 1.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35547 20.5887V16.6671C9.35547 16.147 9.56206 15.6483 9.92978 15.2806C10.2975 14.9128 10.7963 14.7062 11.3163 14.7062H13.2771C13.7972 14.7062 14.2959 14.9128 14.6637 15.2806C15.0314 15.6483 15.238 16.147 15.238 16.6671V20.5887",
    stroke: "#676767",
    strokeWidth: 1.57,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5982_25762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.53,
    height: 23.53,
    fill: "white",
    transform: "translate(0.53125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/Marketing.aa9d982ae0033e7b7ae6e9ee59c774f9.svg";
export { ForwardRef as ReactComponent };